import { render, staticRenderFns } from "./announcementCreate.vue?vue&type=template&id=71773e24&"
import script from "./announcementCreate.vue?vue&type=script&lang=js&"
export * from "./announcementCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports